module.exports = __webpack_public_path__ + "static/media/squareHookNew.9d7e1c4a.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/squareHookNew.png
// module id = 684
// module chunks = 0 1